module.exports = __webpack_public_path__ + "img/party_popper.1d6ddfb5.gif";